import { Component, OnInit } from '@angular/core';
import { MatAutocompleteSelectedEvent, MatDialogRef } from '@angular/material';
import { UserIface } from '../../../../interfaces/user.iface';
import { Observable } from 'rxjs/internal/Observable';
import { FormControl } from '@angular/forms';
import { debounce, switchMap } from 'rxjs/operators';
import { UserService } from '../../../../services/user.service';
import { timer } from 'rxjs/internal/observable/timer';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-add-user-hierarchy',
  templateUrl: './add-user-hierarchy-dialog.component.html',
  styleUrls: ['./add-user-hierarchy-dialog.component.scss']
})
export class AddUserHierarchyDialogComponent implements OnInit {
  public names: string[] = [];

  public userFilter: FormControl = new FormControl();
  public filteredOptions: Observable<UserIface[]>;

  private static getUsernameDBFilter(username: string): object {
    return { username: { $regex: username, $options: 'i' } };
  }

  constructor(
    private dialogRef: MatDialogRef<AddUserHierarchyDialogComponent>,
    private userService: UserService,
    private translate: TranslateService
  ) {
    const browserLang = translate.currentLang;
    translate.use(browserLang.match(/en|pl/) ? browserLang : 'pl');
  }

  ngOnInit() {
    this.filteredOptions = this.userFilter.valueChanges.pipe(
      debounce(() => timer(400)),
      switchMap(val => this.userService.findAll(AddUserHierarchyDialogComponent.getUsernameDBFilter(val), 0, 0))
    );
  }

  addUser(selected: MatAutocompleteSelectedEvent): void {
    this.names.push(selected.option.value);
  }

  deleteUser(index: number): void {
    this.names.splice(index, 1);
  }

  save(names: string[]): void {
    this.dialogRef.close(names);
  }
}
